import { render } from "./UnderlinedH1.vue?vue&type=template&id=6f6c85bc"
import script from "./UnderlinedH1.vue?vue&type=script&lang=js"
export * from "./UnderlinedH1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__